import * as React from 'react';

import { ListSkeleton } from '@gitbook/spine-react';

import { UpgradeDialogProvider } from '../../UpgradeDialog';
import type { ShareContentModalProps } from '../types';
import { InviteMembersInput } from './InviteMembersInput';

const ContentPermissionsList = React.lazy(() => import('./ContentPermissionsList'));
const OrganizationInviteLinks = React.lazy(() => import('./OrganizationInviteLinks'));

/**
 * Modal for the permissions for a given content.
 */
export function InviteMembers(props: ShareContentModalProps): React.ReactElement {
    const { content } = props;
    return (
        <UpgradeDialogProvider>
            <div className="flex flex-col gap-6 divide-y">
                <div className="flex flex-col gap-6">
                    <InviteMembersInput {...props} />
                    <div className="flex flex-col gap-4">
                        <div className="text-ui-small text-muted">Who has access</div>
                        <React.Suspense fallback={<ListSkeleton items={3} />}>
                            <ContentPermissionsList content={content} />
                        </React.Suspense>
                    </div>
                </div>
                <React.Suspense fallback={null}>
                    <OrganizationInviteLinks {...props} />
                </React.Suspense>
            </div>
        </UpgradeDialogProvider>
    );
}
